import dayjs from 'dayjs';

const generateMockedDate = (numDays: number, operation: 'add' | 'subtract' = 'add'): string => {
  switch (operation) {
    case 'add':
      return dayjs().add(numDays, 'days').format('YYYY-MM-DDTHH:mm:ss');

    case 'subtract':
      return dayjs().subtract(numDays, 'days').format('YYYY-MM-DDTHH:mm:ss');
  }
};

export default generateMockedDate;
